import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { $, $$, getElementPosition, EventManager } from "./recruit-utils.js";
import { performRobustScroll } from "../../_smoothScroll.js";

/**
 * Recruit Animation - Side Navigation
 * サイドナビゲーション制御（簡素化版）
 */

export function initSideNavigation() {
  // PCのみで動作（768px以上）
  if (window.innerWidth <= 768) return;

  const sideNav = $('.p-recruit-layout__side');
  const layout = $('.p-recruit-layout');
  
  if (!sideNav || !layout) return;

  // 固定位置制御
  setupFixedPositioning(sideNav, layout);
  
  // セクションアクティブ状態の監視
  setupSectionActiveStates();
  
  // スムーススクロール
  setupSmoothScroll();
  
  // 初期化後にScrollTriggerを再計算して位置を正確にする
  setTimeout(() => {
    ScrollTrigger.refresh();
  }, 100);

  // FAQ展開時の高さ変更に対応
  window.addEventListener('heightChanged', () => {
    setTimeout(() => {
      ScrollTrigger.refresh();
    }, 100);
  });
}

function setupFixedPositioning(sideNav, layout) {
  // is-stickyクラスの付与
  ScrollTrigger.create({
    trigger: layout,
    start: "top top",

    onEnter: () => {
      if (!document.body.classList.contains('hero-animating')) {
        sideNav.classList.add('is-sticky');
      }
    },

    onLeaveBack: () => {
      sideNav.classList.remove('is-sticky');
    }
  });

  // height: autoのクラス付与（少し遅らせる）
  ScrollTrigger.create({
    trigger: layout,
    start: "top -200px",

    onEnter: () => {
      if (!document.body.classList.contains('hero-animating')) {
        sideNav.classList.add('is-visible');
      }
    },

    onLeaveBack: () => {
      sideNav.classList.remove('is-visible');
    }
  });
}

function setupSectionActiveStates() {
  const header = $('.l-header') || $('.l-header--recruitment');
  const headerHeight = header ? header.offsetHeight : 80;
  
  const sectionNavMap = [
    { sectionId: 'system', href: '#system' },
    { sectionId: 'value', href: '#value' },
    { sectionId: 'interview', href: '#interview' },
    { sectionId: 'environment', href: '#environment' },
    { sectionId: 'data', href: '#data' },
    { sectionId: 'requirements', href: '#requirements' }, // FAQまで含める
    { sectionId: 'message', href: '#message' }
  ];
  
  const navLinks = Array.from($$('.p-recruit-layout__nav-link'));
  const sideNav = $('.p-recruit-layout__side');
  
  // スタッフセクションでサイドナビを白色にする
  const staffSection = $('.p-recruit-staff');
  if (staffSection && sideNav) {
    ScrollTrigger.create({
      trigger: staffSection,
      start: "top top",
      end: "bottom center",
      refreshPriority: -2,
      invalidateOnRefresh: true,
      onToggle: (self) => {
        sideNav.classList.toggle('is-white', self.isActive);
      }
    });
  }
  
  sectionNavMap.forEach(({ sectionId, href }) => {
    const sectionEl = $(`#${sectionId}`);
    if (!sectionEl) return;
    
    // 採用情報セクションの場合は、FAQセクションまでを範囲に含める
    let endTrigger = sectionEl;
    let endPosition = "bottom 20%";
    
    if (sectionId === 'requirements') {
      const faqSection = $('#faq');
      if (faqSection) {
        endTrigger = faqSection;
        endPosition = "bottom 20%";
      }
    }
    
    ScrollTrigger.create({
      trigger: sectionEl,
      start: "top 50%",
      endTrigger: endTrigger,
      end: endPosition,
      refreshPriority: -2,
      invalidateOnRefresh: true,
      onToggle: (self) => {
        if (self.isActive) {
          setActiveNavByHref(navLinks, href);
        }
      }
    });
  });
}

function setActiveNavByHref(navLinks, targetHref) {
  navLinks.forEach(link => {
    const isActive = link.getAttribute('href') === targetHref;
    link.classList.toggle('is-active', isActive);
  });
}

function setupSmoothScroll() {
  const eventManager = new EventManager();
  const navLinks = $$('.p-recruit-layout__nav-link[href^="#"]');
  
  navLinks.forEach(link => {
    eventManager.add(link, 'click', (e) => {
      e.preventDefault();
      const targetId = link.getAttribute('href').substring(1);
      const targetElement = $(`#${targetId}`);
      
      if (targetElement) {
        performRobustScroll(targetElement, 1000);
      }
    });
  });
}